const REALNESS_STYLE = {
  human: "text-[#4ADE80] border-[#4ADE80]",
  suspicious: "text-[#FF5C5C] border-[#FF5C5C]",
  bot: "text-[#FF5C5C] border-[#FF5C5C]",
  flagged: "text-[#FF5C5C] border-[#FF5C5C]",
  pending: "text-[#D6D6D6] border-[#2E2E2E]",
};

const Badge = ({ value, styleMap }) => (
  <span className={`text-[15px] font-semibold border rounded-full px-2.5 py-0.5 ${styleMap?.[value] || "text-[#D6D6D6] border-[#2E2E2E]"}`}>
    {value || "—"}
  </span>
);

export const ContactsView = ({ data }) => {
  if (!data) return <p className="text-[17px] font-medium text-[#D6D6D6]">Loading...</p>;

  return (
    <div className="space-y-6" data-testid="contacts-view">
      <div className="rounded-2xl border border-[#2E2E2E] bg-[#050505]">
        <p className="text-base font-bold text-white p-5 pb-3">Contacts ({data.contacts.length})</p>
        <div className="overflow-x-auto pb-2">
          <table className="w-full text-[17px] font-medium">
            <thead>
              <tr className="text-[#D6D6D6] font-semibold text-left">
                <th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Company</th>
                <th className="p-4">Type</th><th className="p-4">Data interests</th><th className="p-4">Realness</th><th className="p-4">Consent</th><th className="p-4">Date</th>
              </tr>
            </thead>
            <tbody>
              {data.contacts.map((c) => (
                <tr key={c.id} className="odd:bg-[#111111] text-[#D6D6D6] align-top" data-testid="contact-row">
                  <td className="p-4 text-white">{c.name}</td>
                  <td className="p-4">{c.email}</td>
                  <td className="p-4">{c.company || "—"}</td>
                  <td className="p-4"><Badge value={c.contact_type} /></td>
                  <td className="p-4">
                    <div className="flex flex-wrap gap-1 max-w-[180px]">
                      {(c.data_interests || []).map((d) => (
                        <span key={d} className="text-[15px] font-semibold border border-[#FF5C5C] text-[#FF5C5C] rounded-full px-2.5 py-0.5">{d}</span>
                      ))}
                      {(!c.data_interests || c.data_interests.length === 0) && <span className="text-[#D6D6D6]">—</span>}
                    </div>
                  </td>
                  <td className="p-4">
                    <Badge value={c.realness} styleMap={REALNESS_STYLE} />
                    {c.realness_rationale && <p className="text-[#D6D6D6] text-[15px] mt-1 max-w-[220px]">{c.realness_rationale}</p>}
                  </td>
                  <td className="p-4">
                    {c.sms_consent_record ? (
                      <div className="max-w-[240px]" data-testid="sms-consent-record">
                        <span className={c.sms_consent_record.sms_consent ? "text-[#4ADE80] font-semibold" : "text-[#D6D6D6] font-semibold"}>
                          SMS: {c.sms_consent_record.sms_consent ? "Yes" : "No"}
                        </span>
                        <p className="text-[#D6D6D6] text-[15px] mt-0.5">{new Date(c.sms_consent_record.timestamp).toLocaleString()}</p>
                        <details className="mt-1">
                          <summary className="text-[15px] font-semibold text-[#38BDF8] cursor-pointer">Proof record</summary>
                          <div className="text-[15px] text-[#D6D6D6] mt-1 space-y-1">
                            <p>IP: {c.sms_consent_record.ip || "—"}</p>
                            <p className="break-all">Page: {c.sms_consent_record.page_url || "—"}</p>
                            <p className="break-all">Agent: {(c.sms_consent_record.user_agent || "—").slice(0, 80)}</p>
                            <p className="italic">"{c.sms_consent_record.label_text}"</p>
                          </div>
                        </details>
                      </div>
                    ) : c.consent?.granted ? (
                      <span className="text-[#4ADE80]">Yes · {c.consent.version}<br /><span className="text-[#D6D6D6] text-[15px]">{new Date(c.consent.at).toLocaleString()}</span></span>
                    ) : "—"}
                  </td>
                  <td className="p-4 text-[#D6D6D6]">{new Date(c.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
              {data.contacts.length === 0 && <tr><td colSpan={8} className="p-4 text-[#D6D6D6]">No contacts yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      <div className="rounded-2xl border border-[#2E2E2E] bg-[#050505]">
        <p className="text-base font-bold text-white p-5 pb-3">Bookings ({data.bookings.length})</p>
        <div className="overflow-x-auto pb-2">
          <table className="w-full text-[17px] font-medium">
            <thead>
              <tr className="text-[#D6D6D6] font-semibold text-left">
                <th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Time</th><th className="p-4">Contact</th><th className="p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {data.bookings.map((b) => (
                <tr key={b.id} className="odd:bg-[#111111] text-[#D6D6D6]" data-testid="booking-row">
                  <td className="p-4 text-white">{b.name}</td>
                  <td className="p-4">{b.email}</td>
                  <td className="p-4">{new Date(b.slot).toLocaleString()}</td>
                  <td className="p-4 text-[#D6D6D6]">{b.contact_id ? `${b.contact_id.slice(0, 8)}...` : "—"}</td>
                  <td className={`p-4 font-semibold ${b.status === "confirmed" ? "text-[#4ADE80]" : "text-[#D6D6D6]"}`}>{b.status}</td>
                </tr>
              ))}
              {data.bookings.length === 0 && <tr><td colSpan={5} className="p-4 text-[#D6D6D6]">No bookings yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
